const tpl = `<div class="help-body">
                   <div class="icon-help help-entry">
                       <div class="help-tip">点我展开哦~</div>
                   </div>
                   <div class="help-menu">
                       <div class="help-tip">点我就收起哦~</div> 
                       <div class="help-panel">
                            <div class="help-guess"> 
                                 <div class="icon-help help-menu-close"></div>
                                   <span class="question">猜你想问</span> 
                            </div>
                            <ul class="help-ul"></ul>
                       </div>
                   </div>
                   <div class="help-chat-body">
                       <div class="help-chat-panel">
                            <div class="help-chat-header">
                              <div class="help-chat-default-avatar icon-help"></div>
                              <div class="help-chat-name">
                                  <span>我是您的小助手，时刻为您解决疑难问题！</span>
                                  <span class="question">帮助中心</span>
                              </div>
                              <div class="help-chat-close"></div>
                            </div>
                            <div class="help-chat-content">
                                <div class="context-left">
                                    <span class="help-chat-text">您好，我是您的专属助理，有什么疑问，让我来帮你解答！</span>
                                </div>
                            </div>
                            <div class="help-send-message">
                                  <textarea placeholder="您好，我是您的专属助理，有什么疑问，让我来帮你解答！" class="help-input-message" rows="6" required maxlength="2048"></textarea>
                                  <button class="help-send-button">发送</button>
                                  <div class="help-notice">Ctrl + Enter 换行, Enter发送</div>
                            </div>
                       </div>
                   </div>
            </div>`


export default tpl
